import React, { useState, useCallback, useEffect } from 'react';
import { useParams } from "react-router-dom";
import { Page, Layout, Banner, LegacyCard, FormLayout, TextField, Button, Form, Text } from '@shopify/polaris';
import { SkeletonPageCustom } from './SkeletonPageCustom';
import { loadTawk } from '../Utils';

export function Login(props) {

    const params = useParams();

    const [loading, setLoading] = useState(true);
    const [errorMessage, setErrorMessage] = useState('');
    const [shopName, setShopName] = useState('');
    const [coupon, setCoupon] = useState('');
    const [shopNameError, setShopNameError] = useState('');

    const populateData = async () => {
        props.setIsLoading(true);

        var url = 'api/home/login';
        if (params.error) {
            url += '?error=' + params.error;
        }
        else if (params.state) {
            url += '?state=' + params.state;
        }

        const response = await fetch(url);
        const data = await response.json();

        props.setIsLoading(false);

        if (data.token) {
            localStorage.setItem('token', data.token);
            window.location.href = '/';
        }
        else {
            setErrorMessage(data.errorMessage);
            setLoading(false);

            loadTawk('Guest', 'Guest');
        }
    };

    //const submitLogin = async () => {
        
    //};

    const handleChange = useCallback(
        (fieldName, newValue) => {
            if (fieldName === 'shopName') {
                setShopName(newValue);
                setShopNameError('');
            }
            else if (fieldName === 'coupon') {
                setCoupon(newValue);
            }
        },
        [],
    );

    const handleLogIn = useCallback(
        async () => {
            if (!shopName) {
                setShopNameError('Shop name field is required.');
                return;
            }

            props.setIsLoading(true);
            const response = await fetch('api/home/submitLogin', { method: 'post', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ shopName: shopName, coupon: coupon }) });
            const data = await response.json();
            props.setIsLoading(false);

            if (response.ok === true) {
                if (data.redirectUrl) {
                    window.location.href = data.redirectUrl;
                }
                else {
                    localStorage.setItem('token', data.token);
                    window.location.href = '/';
                }
            }
        },
        [shopName, coupon, props],
    );

    useEffect(() => {
        document.title = "Login | Stack Discounts";
        populateData();
        // eslint-disable-next-line
    }, []);

    const errorMessageP = errorMessage ? (
        <p>{errorMessage}</p>
    ) : null;

    return (
        loading ?
            <SkeletonPageCustom />
            :
            <Page title="Log in">
                <Layout>
                    <Layout.Section>
                        <Banner
                            title="Log into Stack Discounts | PG"
                            status="warning"
                        >
                            <p>It seems your session ended. Please log into the app by going to your <b>Shopify store admin -&#x3e; Apps -&#x3e; Stack Discounts | PG</b> or use the form below.</p>
                        </Banner>
                    </Layout.Section>
                    <Layout.Section>
                        <LegacyCard sectioned>
                            <Form onSubmit={() => handleLogIn()}>
                                <FormLayout>
                                    <TextField
                                        label="Shop name"
                                        placeholder="shopname"
                                        suffix=".myshopify.com"
                                        value={shopName}
                                        error={shopNameError}
                                        onChange={(newValue) => handleChange('shopName', newValue)} />
                                    <TextField
                                        label="Coupon (optional)"
                                        placeholder="coupon"
                                        value={coupon}
                                        onChange={(newValue) => handleChange('coupon', newValue)} />
                                    <Text as="span" tone="critical">{errorMessageP}</Text>
                                    <Button submit>Log In</Button>
                                </FormLayout>
                            </Form>
                        </LegacyCard>
                    </Layout.Section>
                </Layout>
            </Page>
    );
}